import revopsIcon from '@/assets/revopsai-icon.png';

interface RevOpsLogoProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'light' | 'dark' | 'icon-only';
  className?: string;
}

export function RevOpsLogo({ size = 'md', variant = 'dark', className = '' }: RevOpsLogoProps) {
  const sizes = {
    sm: { icon: 28, text: 'text-base', gap: 'gap-1.5' },
    md: { icon: 36, text: 'text-xl', gap: 'gap-2' },
    lg: { icon: 40, text: 'text-2xl', gap: 'gap-2.5' },
  };

  const s = sizes[size];
  const textColor = variant === 'light' ? 'text-white' : 'text-[#1A1F3C]';

  return (
    <span className={`inline-flex items-center ${s.gap} ${className}`}>
      <img
        src={revopsIcon}
        alt="RevOps AI"
        width={s.icon}
        height={s.icon}
        className="flex-shrink-0 rounded-lg"
      />

      {variant !== 'icon-only' && (
        <span className={`${s.text} font-bold ${textColor} leading-none`}>
          RevOps<span className="text-[#4F6CFF]"> AI</span>
        </span>
      )}
    </span>
  );
}
